module.exports = __webpack_public_path__ + "static/media/edu2.bb842275.jpeg";